/**
 * Shared Thai locale — common strings reused across multiple modules.
 */

export const th = {
  // --- Buttons / Actions ---
  cancel: 'ยกเลิก',
  confirm: 'ยืนยัน',
  save: 'บันทึก',
  delete: 'ลบ',
  edit: 'แก้ไข',
  close: 'ปิด',
  add: 'เพิ่ม',
  remove: 'ลบออก',
  download: 'ดาวน์โหลด',
  upload: 'อัปโหลด',
  submit: 'ส่ง',
  back: 'กลับ',
  next: 'ถัดไป',
  yes: 'ใช่',
  no: 'ไม่',
  retry: 'ลองอีกครั้ง',
  search: 'ค้นหา',
  clear: 'ล้าง',
  apply: 'ใช้',
  login: 'เข้าสู่ระบบ',
  continue: 'ไปหน้าถัดไป',
  ok: 'ตกลง',

  // --- States ---
  loading: 'กำลังโหลด...',
  noResults: 'ไม่มีผลลัพธ์',
  errorOccurred: 'เกิดข้อผิดพลาด',
  errorRetryMessage: 'กรุณาลองใหม่อีกครั้ง',
  areYouSure: 'คุณแน่ใจหรือไม่?',

  // --- Common field labels / column headers ---
  id: 'หมายเลข',
  status: 'สถานะ',
  details: 'รายละเอียด',
  name: 'ชื่อ',
  createdOn: 'สร้างวันที่',
  agent: 'ตัวแทน',
  customer: 'ลูกค้า',

  // --- Download feedback ---
  downloadStarted: 'เริ่มดาวน์โหลดแล้ว',
  downloadStartedDescription: 'กำลังดาวน์โหลดเอกสารของคุณ',
  // --- Backend error messages (used by utils/helper errorHandler) ---
  // Keys are raw backend error identifiers/strings; values are user-facing messages.
  errorMessages: {
    required: 'กรุณากรอกข้อมูล',
    referralCode: 'Enter referral code',
    email: 'ที่อยู่อีเมลไม่ถูกต้อง',
    phone: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
    alreadyRegistered: 'คุณได้ทำการลงทะเบียนแล้ว กรุณาล็อคอิน',
    groupName: 'ตั้งชื่อกลุ่ม',
    password: 'รหัสผ่านไม่ถูกต้อง',
    comparePassword: 'รหัสผ่านทั้งสองช่องไม่ตรงกัน',
    oldNewPassword: 'รหัสผ่านเดิมและใหม่ต้องไม่เหมือนกัน',
    wrongPassword: 'รหัสผ่่านผิด',
    emailNotVerified: 'อีเมลไม่ได้รับการยืนยัน',
    fileSize: 'ขนาดไฟล์ต้องไม่เกิน 2MB',
    uploadFileRequired: 'โปรดอัพโหลด',
    'Missing required field': 'กรุณากรอกข้อมูล',
    savedSuccessfully: 'ได้บันทึกข้อมูลเรียบร้อย',
    invalidPostalCode: 'ไม่ถูกต้อง เขต/อำเภอ',
    unregisteredEmail: 'อีเมล์นี่ยังไม่ได้ลงทะเบียน',
    confirmationText: 'ุณแน่ใจไหม?',
    invalidDateMessage: 'รูปแบบวันที่ไม่ถูกต้อง',
    minDateMessage: 'สามารถระบุเริ่มคุ้มครองได้วันนี่ถึง90วันล่วงหน้า',
    'File is too large': 'ตัวไฟล์ใหญ่(เกิน 25 mb) จังไม่สามารถไปเปลี่ยนได้',
    invalidFormat: 'รูปแบบไม่ถูกต้อง',
    noInsurerInFairdee: 'FairDee has not yet proceeded with this insurance company.',
    incorrectInfo: 'ข้อมูลไม่ถูกต้อง',
    successfulSignup: 'ลงชื่อเข้าใช้สำเร็จ',
    updatedSuccessfully: 'อัปเดตเรียบร้อยแล้ว',
    copied: 'คัดลอกข้อความแล้ว',
    loseData: 'ยืนยันว่าอยากไปจากหน้านี้? ข้อมูลที่กรอกไว้จะหายไป',
    noBrokerMessage:
      'หมายเหตุ: หากคุณไม่มีใบอนุญาตนายหน้าประกันวินาศภัย คุณจะมีสถานะเป็นสมาชิกซึ่งสิทธิได้รับส่วนลดในการซื้อประกัน แต่จะไม่สามารถสร้างใบเสนอราคาและรับผลตอบแทนได้',
    confirmationQuestion: 'คุณแน่ใจไหม?',
    maxDiscount: 'ส่ว่นลดสูงสุดคือ',
    baht: 'บาท',
    lessValue: 'ควรจะน้อยกว่า',
    characters: 'ตัวอักษร',
    moreValue: 'Value should be more than',
    upload: 'อัพโหลด',
    linkCopied: 'ลิงค์ถูกคัดลอกเรียบร้อย',
    successfullFileUpload: 'อัปโหลดไฟล์สำเร็จแล้ว',
    accepted: 'ได้รับการยืนยัน',
    rejected: 'ปฏิเสธ',
    takeAction: 'เริ่มปฏิบัติ',
    select: 'เลือก',
    deletedSuccessfully: 'ลบสำเร็จแล้ว',
    createdSuccessfully: 'Created Succesfully',
    'Ensure this field has no more than 10 characters.': 'ตรวจสอบให้แน่ใจว่าฟิลด์นี้มีอักขระไม่เกิน 10 ตัว',
    'This value does not match the required pattern.': 'ค่านี้ไม่ตรงกับรูปแบบที่ต้องการ',
    'Invalid value specified': 'ระบุค่าไม่ถูกต้อง',
    broker_license_number: 'เลขบัตรนายหน้าประกันวินาศภัย',
    reconciled: 'Reconciled',
    contractExists: 'สัญญานี้ถูกสร้างอยู่แล้ว แน่ใจหรือไม่ว่าจะสร้างใหม่',
    generatedSuccessfully: 'สัญญาเสร็จสมบูรณ์',
    will_pay_in_instalments_limit: 'การซื้อครั้งนี้จะเกินวงเงิน 75,000 บาท',
    moreThanOrEqual: 'ต้องมีค่ามากกว่า หรือ เท่ากันเท่านั้น',
    resetDiscount: 'การตัดบัตรเครดิตต้องตัดยอดเต็มเท่านั้น กรุณายืนยันการนำส่วนลดตัวแทนออก',
    resetPasswordEmailSent: 'อีเมลล์สร้างรหัสผ่านใหม่ได้ถูกส่งไปยังอีเมลล์ของท่านเรียบร้อยแล้ว',
    'Invalid credentials given.': 'ระบุข้อมูลรับรองไม่ถูกต้อง',
    bannedUser: 'โปรดติดต่อเจ้าหน้าที่ปลดการระงับบัญชี',
    'Running cover/purchase request already exists for this national ID':
      'ลูกค้ารายนี้มีการซื้อกรมธรรม์ไปแล้ว/ลูกค้ารายนี้ได้มีการคีย์งานไว้แล้ว (แต่ยังไม่ออกกรมธรรม์)',
    emailAlreadyExists: 'Duplicate Email. Please use a different email',
    uploadPolicy: 'กรุณาอัพโหลดไฟล์กรมธรรม์',
    house_number: 'บ้านเลขที่',
    ac_number:
      'บัญชีนี้ ใช้ผูกกับรหัสตัวแทนหมายเลขอื่นแล้ว กรุณาเลือกบัญชีใหม่ หรือติดต่อเจ้าหน้าที่เพื่อขอความช่วยเหลือ',
    'Not eligible for free vaccine insurance': 'ไม่ได้เข้าร่วมโครงการแจกฟรีกรมธรรม์แพ้โควิท',
    'Free insurance already availed, check Policy in progress table':
      'คุณได้รับกรมธรรม์ฟรีเรียบร้อย เข้าไปตรวจสอบไปที่ปุ่มตรวจสอบสถานะกรมธรรม์',
    'Policy Number already exists for another policy.': 'เลข กธ. นี้ซ้ำ กรุณาตรวจสอบอีกครั้ง',
    purchasedSuccessfully: 'Policy Purchased Successfully',
    'Failed to upload policy into the system': 'ระบบไม่สามารถอัพโหลดไฟล์ กธ. ได้',
    incorrectCalculationGrossPremium: 'ผลรวมของ (เบี้ยสุทธิ+ภาษี+อากร) ต้องเท่ากับ เบี้ยรวม หรือน้อยกว่าไม่เกิน 1 บาท',
    'Branch Code can only have 4 characters': 'รหัสสาขาต้องมีตัวเลข 4 หลัก เท่านั้น',
    'Cannot downgrade level': 'ไม่สามารถปรับระดับให้ต่ำลงได้',
    'Cannot update once endorsement request is sent to insurer. For any updates you must delete this and create new endorsement request.':
      'หลังจากที่คำขอสลักหลังถูกส่งออกให้บริษัทประกัน จะไม่สามารถอัพเดทรายละเอียดสลักหลังเพิ่มเติมได้ หากต้องการที่จะอัพเดทรายละเอียดสลักหลัง กรุณาลบรายการสลักหลังที่ต้องการที่อัพเดทแล้วสร้างใหม่',
    'Cannot update once endorsement is approved.': 'ไม่สามารถอัพเดทรายการสลักหลังได้หากได้รับอนุมัติแล้ว',
    'Endorsement for cancellation of cmi is already recorded in system':
      'สลักหลังยกเลิก พรบ ได้ถูกบันทึกในระบบเรียบร้อย',
    'Please reconcile the payment in customer invoice': ' กรุณา reconcile payment ใน customer invoice',
    'Will pay in instalments not allowed for inspection_garage': 'ไม่อนุญาตให้ตรอ.ผ่อนเงินสด ณ ขณะนี้',
    'Will pay in instalments not allowed for subagent': 'ไม่อนุญาตให้ตรอ.ผ่อนเงินสด ณ ขณะนี้',
    vehicleWeight: 'กรุณาระบุน้ำหนัก โลกรัม',
    'Please enter a customer number different from agent phone number':
      'กรุณาใส่เบอร์โทรศัพท์ของลูกค้าให้แตกต่างจากเบอร์โทรศัพท์ของตัวแทน',
    'Your order is processing.': 'กำลังดำเนินการซื้อพ.ร.บ.',
    'Please do not reload or close this page': '(กรุณาอย่ากด refresh หรือปิด website)',
    failedGetDescData: 'ล้มเหลวในการรับข้อมูลคำอธิบาย โปรดติดต่อฝ่ายสนับสนุนของเรา',
    'Image failed to meet OCR requirements, please try again': 'อัพโหลดไม่ผ่าน กรุณาลองใหม่อีกครั้ง',
    'Use of I, O, Q is restricted': 'ห้ามใส่ I O Q',
    'Engine number can’t exceed 17 characters': 'เลขเครื่องยนต์ห้ามเกิน 17 ตัวอักษรเท่านั้น',
    '11-17 characters only': '11-17 ตัวอักษรเท่านั้น',
    'ห้ามคีย์ช่องว่างและภาษาไทยและอักขระ พิเศษลงในช่องเลขตัวถัง':
      'ห้ามคีย์ช่องว่างและภาษาไทยและอักขระ พิเศษลงในช่องเลขตัวถัง',
    'Use of ฏ, ฃ, ฅ, ซ is restricted': 'ห้ามมีตัวอักษร ฏ ฃ ฅ ซ',
    '3-8 characters only': '3-8 ตัวอักษรเท่านั้น',
    'Don’t enter province': 'ห้ามใส่จังหวัด',
    'The vehicle number is wrong': 'ทะเบียนรถไม่ถูกต้อง',
    'กรุณาใส่ - หรือเว้นว่างเพื่อขีดขั้นเลขทะเบียน เช่น 2รน-2343 หรือ 2รน 2343':
      'กรุณาใส่ - หรือเว้นว่างเพื่อขีดขั้นเลขทะเบียน เช่น 2รน-2343 หรือ 2รน 2343',
    'กรุณาใส่ - เพื่อขีดขั้น ในช่องทะเบียนรถ': 'กรุณาใส่ - เพื่อขีดขั้น ในช่องทะเบียนรถ',
    'เลขทะเบียนรถผิด(อักษรไทย-อังกฤษและตัวเลขเท่านั้น)': 'เลขทะเบียนรถผิด(อักษรไทย-อังกฤษและตัวเลขเท่านั้น)',
    หมายเลขทะเบียนรถควรประกอบด้วยตัวอักษรภาษาไทยและตัวเลขเท่านั้น:
      'หมายเลขทะเบียนรถควรประกอบด้วยตัวอักษรภาษาไทยและตัวเลขเท่านั้น',
    'Added By AI': 'เพิ่มโดย AI',
    'Something Went Wrong!': 'พบข้อผิดพลาดทางระบบ',
  },

  // --- Global header filters ---
  owner: 'ผู้รับผิดชอบ',
  ownerSelectedCount: 'เลือกแล้ว {{count}} รายการ',
  ownerSearchPlaceholder: 'ค้นหาเจ้าหน้าที่...',
  ownerNoResults: 'ไม่พบเจ้าหน้าที่',
  ownerClearAll: 'ล้างผู้ดูแลทั้งหมด',

  // --- Date range filter ---
  dateRangeTo: 'ถึง',
  dateRangeEmpty: '00 เดือน ถึง 00 เดือน',
  dateRangeMaxExceeded: 'ช่วงวันที่ต้องไม่เกิน {{months}} เดือน กรุณาเลือกช่วงที่สั้นลง',

  // --- Document preview (shared block) ---
  documentPreviewLoadingPdf: 'กำลังโหลด PDF…',
  documentPreviewFailedPdf: 'ไม่สามารถโหลดเอกสาร PDF ได้',
  documentPreviewFailedImage: 'ไม่สามารถโหลดรูปภาพได้',
  documentPreviewFailedDocument: 'ไม่สามารถโหลดเอกสารได้',
  documentPreviewUnsupported: 'ไม่รองรับไฟล์ประเภทนี้',
  documentPreviewPrevious: 'ก่อนหน้า',
  documentPreviewNext: 'ถัดไป',
  documentPreviewPageOf: '{{page}} จาก {{total}}',
  documentPreviewShare: 'แชร์',
  documentPreviewDownload: 'ดาวน์โหลด',
  documentPreviewDownloadFile: 'ดาวน์โหลดไฟล์',
  documentPreviewUrlCopied: 'คัดลอก URL แล้ว',
  documentPreviewPasswordRequired: 'เอกสารนี้ต้องใช้รหัสผ่านในการเปิด คุณสามารถดาวน์โหลดแทนได้',
  documentPreviewPasswordPrompt: 'เอกสาร PDF นี้มีรหัสผ่าน กรุณากรอกรหัสผ่าน:',
  documentPreviewPasswordIncorrect: 'รหัสผ่านไม่ถูกต้อง กรุณาลองใหม่:',
  documentPreviewZoomIn: 'ขยาย',
  documentPreviewZoomOut: 'ย่อ',
  documentPreviewResetView: 'รีเซ็ตมุมมอง',
  documentPreviewNoDocument: 'ไม่มีเอกสาร',
  documentPreviewFallbackName: 'เอกสาร',
  // --- Cancellation reasons (shared: policy-in-progress form, endorsement detail, ops card) ---
  endorsementCancellationReasonIncompleteInfo: 'รายละเอียดไม่ครบและไม่สามารถติดต่อลูกค้าเพื่อยืนยันข้อมูลได้',
  endorsementCancellationReasonVehicleInspection: 'ไม่สามารถนัดลูกค้าตรวจสภาพรถ หรือ ยืนยันบาดแผลได้',
  endorsementCancellationReasonInsurerRejected: 'บริษัทประกันปฏิเสธการรับแจ้งงาน',
  endorsementCancellationReasonPaymentDefault: 'ลูกค้านัดผิดชำระ/เกินกำหนด',
  endorsementCancellationReasonCustomerRequest: 'ลูกค้าประสงค์ขอยกเลิกกรมธรรม์',

  // --- Endorsement request scope ---
  requestTypeExternal: 'ประสานงานบริษัทประกัน',
  requestTypeExternalDesc: 'จะมีอีเมลส่งออกไปหาบ.ประกัน',
  requestTypeInternal: 'ประสานงานภายในแฟร์ดี',
  requestTypeInternalDesc: 'ไม่มีอีเมลส่งออกไปหาบ.ประกัน',

  // --- Licence-plate format messages (shared/blocks/plate; information-correction + ops Step 2) ---
  plateRestrictedCharacters: 'ห้ามมีตัวอักษร ฏ ฃ ฅ ซ',
  plateLength: '3-8 ตัวอักษรเท่านั้น',
  plateLengthAzay: '1-11 ตัวอักษรเท่านั้น',
  plateNoProvince: 'ห้ามใส่จังหวัด',
  plateInvalid: 'ทะเบียนรถไม่ถูกต้อง',
  plateSeparatorRequired: 'กรุณาเว้นวรรคหรือใส่ -',
  plateHyphenRequired: 'กรุณาใส่ - เพื่อขีดขั้น ในช่องทะเบียนรถ',
  plateSeparatorExample: 'กรุณาใส่ - หรือเว้นว่างเพื่อขีดขั้นเลขทะเบียน เช่น 2รน-2343 หรือ 2รน 2343',
  plateNoHyphen: 'เลขทะเบียนรถผิด(อักษรไทย-อังกฤษและตัวเลขเท่านั้น)',
  plateThaiDigitsOnly: 'หมายเลขทะเบียนรถควรประกอบด้วยตัวอักษรภาษาไทยและตัวเลขเท่านั้น',
  cancellationBlocksReporting: 'กรมธรรม์นี้อยู่ระหว่างดำเนินการยกเลิก จึงไม่สามารถแจ้งงานได้',

  // --- Agent credit type badge (FTT-16588), see shared/creditType.ts ---
  creditTypePrepaid: 'เติมเงิน',
  creditTypePostpaid: 'วางบิล',
} as const;
